define('PriceMatch.Form.View',
  [
    'Backbone',
    'Backbone.FormView',
    'PriceMatch.Model',
    'price_match.tpl',
    'Profile.Model',
    'jQuery',
    'underscore'
  ],
  function (
    Backbone,
    BackboneFormView,
    PriceMatchModel,
    price_match_tpl,
    ProfileModel,
    jQuery,
    _
  ) {
    'use strict';

    return Backbone.View.extend({
      template: price_match_tpl,

      initialize: function (options) {
        this.application = options.application;
        this.item = options.item;
        this.user = options.user;
        this.model = new PriceMatchModel();
      },

      events: {
        'click [data-action="requestPriceMatch"]': 'requestPriceMatch'
      },

      requestPriceMatch: function (e) {
        e.preventDefault();
        jQuery(e.currentTarget).attr('disabled', true);
        var self = this;
        var formData = jQuery(e.target).closest('form');
        var fields = jQuery('[required]');
        var message = '';
        var messageType = 'warning';

        if (this.checkRequiredFields(fields)) {
          message = 'You must fill out all required fields.';
          self.showError(message, messageType, true);
          jQuery('#modal').animate({ scrollTop: 0 }, 'slow');
          return;
        }

        var data = formData.serializeObject();

        this.model.save(data).done(function (response) {
          message = 'You have successfully submitted your Price Match Request';
          self.showConfirmationMessage(message);
          jQuery('#modal').animate({ scrollTop: 0 }, 'slow');
          setTimeout(function () {
            self.showContent();
          }, 3000);
        });
      },

      checkRequiredFields: function (fields) {
        return _.find(fields, function (field) {
          var $field = jQuery(field);
          return !$field.val();
        });
      },

      getContext: function () {
        return {
          item: this.item,
          user: this.user
        };
      }
    });
  });
